import React from 'react';
import VersionCardStyled from './VersionCard.styled';
import Avatar, { AvatarProps } from '@/components/avatar/Avatar';
import Icon from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import StatusPill, { StatusPillColors } from '@/components/statusPill/StatusPill';

export interface VersionCardProps {
  readonly id: string;
  readonly guid: string;
  title: string;
  status: 'running' | 'draft' | 'released' | 'release' | 'live';
  description?: string;
  avatar: AvatarProps;
  /**
   * This can be the date of the commit or who the commit is by
   */
  gitCommitDate: string;
  /**
   * This can be the Id of the commit or the provider e.g Gitlab or Github
   */
  gitCommitId: string;
  /**
   * This is the link to the commit
   */
  gitCommitUrl: string;
  isSelected?: boolean;
  action?: () => void;
}

const VersionCard = ({
  id,
  title,
  description,
  status,
  avatar,
  gitCommitDate,
  gitCommitId,
  gitCommitUrl,
  isSelected,
  action,
}: VersionCardProps) => {
  const capitalise = (string: string) =>
    string?.charAt(0)?.toUpperCase() + string?.slice(1);

  return (
    <VersionCardStyled
      isActive={isSelected}
      role="radio"
      aria-checked={isSelected}
    >
      <div className="version-card__header">
        <a
          href="#"
          className={`version-card__title ${
            title?.length >= 34 ? 'version-card__title__wrap' : ''
          }`}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            if (isSelected) return;
            else {
              if (action) action();
            }
          }}
        >
          {isSelected && (
            <div className="version-card__check-icon--wrapper">
              <Icon
                icon={IconsDictionary.Check}
                height={14}
                width={14}
                color="#fff"
              />
            </div>
          )}
          <span>{title}</span>
        </a>
        <StatusPill
          text={capitalise(status)}
          isHollow
          color={
            status === 'draft'
              ? StatusPillColors.Cobalt
              : status === 'live'
              ? StatusPillColors.Teal
              : status === 'released' || status === 'release'
              ? StatusPillColors.Orange
              : StatusPillColors.Grey
          }
        />
      </div>
      {description && <p className="version-card__text">{description}</p>}
      <div className="version-card__footer">
        <span className="version-card__info">
          <Avatar className="version-card__avatar" {...avatar} />
          {gitCommitDate}
        </span>
        <span className="version-card__info">
          <Icon className="version-card__icon" icon={IconsDictionary.Gitlab} />
          <a
            href={gitCommitUrl}
            className="version-card__info--link"
            target="_blank"
            aria-label={`View changes in Gitlab for commit ID: ${gitCommitId}`}
          >
            {gitCommitId}
          </a>
        </span>
      </div>
    </VersionCardStyled>
  );
};

export default VersionCard;
